module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Born in London in 1964, Mel Walsh spent her childhood in the London Borough of Hackney. In 1983, she trained as a registered nurse at St Bartholomew’s Hospital, London, and then as a midwife at The Homerton Hospital, London. She had a varied career, including working as a practice nurse in busy GP practices in Islington and Newham, and as a volunteer midwife in Lebanon during Civil War. After retiring from nursing, she moved to the west country. "), _c('em', [_vm._v("Prior")]), _vm._v(" "), _c('em', [_vm._v("Knowledge")]), _vm._v(" is her debut novel.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0